import { uiText } from '../../utils/uiTranslation';
import React from 'react';

/**
 * Workflow Connector - SVG lines for connecting tasks
 * Supports vertical, branch-left, branch-right, merge-left, merge-right
 */
const WorkflowConnector = ({
    type = 'vertical',
    height = 30,
    width = 300
}) => {
    const strokeColor = 'rgba(86, 141, 237, 0.5)';
    const strokeWidth = 1.5;

    if (type === 'vertical') {
        return (
            <svg
                className="workflow-connector"
                width={width}
                height={height}
                viewBox={`0 0 ${width} ${height}`}
            >
                <line
                    x1={width / 2}
                    y1={0}
                    x2={width / 2}
                    y2={height}
                    stroke={strokeColor}
                    strokeWidth={strokeWidth}
                />
            </svg>
        );
    }

    if (type === 'branch-left') {
        // Vertical down, then curve left
        return (
            <svg
                className="workflow-connector"
                width={width}
                height={height}
                viewBox={`0 0 ${width} ${height}`}
            >
                <path
                    d={`M ${width / 2} 0 L ${width / 2} ${height / 2} Q ${width / 2} ${height} ${width / 4} ${height}`}
                    fill="none"
                    stroke={strokeColor}
                    strokeWidth={strokeWidth}
                />
            </svg>
        );
    }

    if (type === 'branch-right') {
        // Vertical down, then curve right
        return (
            <svg
                className="workflow-connector"
                width={width}
                height={height}
                viewBox={`0 0 ${width} ${height}`}
            >
                <path
                    d={`M ${width / 2} 0 L ${width / 2} ${height / 2} Q ${width / 2} ${height} ${width * 3 / 4} ${height}`}
                    fill="none"
                    stroke={strokeColor}
                    strokeWidth={strokeWidth}
                />
            </svg>
        );
    }

    if (type === 'branch-split') {
        // Split into left and right branches from center
        return (
            <svg
                className="workflow-connector"
                width={width}
                height={height}
                viewBox={`0 0 ${width} ${height}`}
            >
                {/* Vertical down from center */}
                <line
                    x1={width / 2}
                    y1={0}
                    x2={width / 2}
                    y2={height / 2}
                    stroke={strokeColor}
                    strokeWidth={strokeWidth}
                />
                {/* Horizontal line at midpoint */}
                <line
                    x1={width * 0.15}
                    y1={height / 2}
                    x2={width * 0.85}
                    y2={height / 2}
                    stroke={strokeColor}
                    strokeWidth={strokeWidth}
                />
                {/* Left vertical down */}
                <line
                    x1={width * 0.15}
                    y1={height / 2}
                    x2={width * 0.15}
                    y2={height}
                    stroke={strokeColor}
                    strokeWidth={strokeWidth}
                />
                {/* Right vertical down */}
                <line
                    x1={width * 0.85}
                    y1={height / 2}
                    x2={width * 0.85}
                    y2={height}
                    stroke={strokeColor}
                    strokeWidth={strokeWidth}
                />
            </svg>
        );
    }

    if (type === 'merge-left') {
        // From left, curve to center and down
        return (
            <svg
                className="workflow-connector"
                width={width / 2}
                height={height}
                viewBox={`0 0 ${width / 2} ${height}`}
            >
                <line
                    x1={0}
                    y1={0}
                    x2={0}
                    y2={height / 2}
                    stroke={strokeColor}
                    strokeWidth={strokeWidth}
                />
                <line
                    x1={0}
                    y1={height / 2}
                    x2={width / 2}
                    y2={height / 2}
                    stroke={strokeColor}
                    strokeWidth={strokeWidth}
                />
            </svg>
        );
    }

    if (type === 'merge-right') {
        // From right, curve to center and down
        return (
            <svg
                className="workflow-connector"
                width={width / 2}
                height={height}
                viewBox={`0 0 ${width / 2} ${height}`}
            >
                <line
                    x1={width / 2}
                    y1={0}
                    x2={width / 2}
                    y2={height / 2}
                    stroke={strokeColor}
                    strokeWidth={strokeWidth}
                />
                <line
                    x1={0}
                    y1={height / 2}
                    x2={width / 2}
                    y2={height / 2}
                    stroke={strokeColor}
                    strokeWidth={strokeWidth}
                />
            </svg>
        );
    }

    return null;
};

/**
 * Merge Point Diamond - Small diamond shape at merge points
 */
export const MergePointDiamond = () => (
    <div className="merge-diamond" />
);

/**
 * Add Task Button - Dashed button for adding tasks
 */
export const AddTaskButton = ({ onClick, label = 'Add Task' }) => (
    <button className="workflow-add-task-btn" onClick={onClick}>
        <i className="fa-solid fa-plus" />
        {uiText(label)}
    </button>
);

export default WorkflowConnector;
